import React, { useState } from 'react';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import { Box, Typography } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import FlightIcon from '@mui/icons-material/Flight';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import GppGoodIcon from '@mui/icons-material/GppGood';
import LockIcon from '@mui/icons-material/Lock';
import CloseIcon from '@mui/icons-material/Close';
import FilterDramaIcon from '@mui/icons-material/FilterDrama';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';

// @ts-ignore
import  FlightLogo  from '../../../../assets/icons/Icon_flight.svg';
import LoaderFlightIcon from '../../../../assets/icons/loader_flight.svg';
import LoaderStar from '../../../../assets/icons/loader_star.svg';
import LoaderBag from '../../../../assets/icons/loader_bag.svg';
import LoaderShield from '../../../../assets/icons/loader_shield.svg';
import LoaderTelephone from '../../../../assets/icons/loader_telephone.svg';

declare global {
  interface Window {
    phone_number?:string;
  }
}
const LogosAnimation = () => {
  const { t } = useTranslation();
  const [modalHide, setModalHide] = useState(true);
  const isMobile = useMediaQuery('(max-width:576px)');

  const icons = [
    <FlightLandIcon style={{ fontSize: 80 }} />,
    <FlightTakeoffIcon style={{ fontSize: 80 }} />,
    <FlightLandIcon style={{ fontSize: 80 }} />,
    <FlightTakeoffIcon style={{ fontSize: 80 }} />,
  ];
  const imgLog = [
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ac.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/dl.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ws.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ua.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ts.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/aa.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/af.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/de.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/tp.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/lx.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/os.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ac.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/dl.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ws.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ua.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ts.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/aa.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/af.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/de.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/tp.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/lx.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/os.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ei.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ws.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ua.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ts.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/aa.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/af.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/de.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/tp.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/fi.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/os.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ei.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ws.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ua.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/ts.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/aa.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/af.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/de.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/tp.png",
    "https://travel-img-assets.s3.us-west-2.amazonaws.com/flights/carrier-48x48/fi.png",

  ];
  const handleModalClose = () => {
    setModalHide(false);
  }

  return (<>
    {/* <div className='LoaderContainer'>
    <div className="Loader_iconsWrapper"> */}
    {/* {icons.map((icon, index) => (
        <div
          key={index}
          className="icon"
          style={{ animationDelay: `${index * 3}s` }} // Stagger the start time for each icon
        >
          {icon}
        </div>
      ))} */}
    {/* animation old */}
    {/* {imgLog.map((icon, index) => (
        <div
          key={index}
          className="icon"
          // style={{ animationDelay: `${ 0.1}s` }} // Stagger the start time for each icon
        >
       <img src={icon} width={'50px'}/>
        </div>
      ))} */}
    {/* animation old */}



    {/* </div>
    </div> */}
    {modalHide &&
      <Box className="SearchFare_Wrapper">
        <Box className="SearchFare_LoaderWarpper">
          {/* <CloseIcon className="SearchFare_LoaderCloseIcon" onClick={handleModalClose} /> */}
          <Box className="SearchFare_LoaderInfo">
            <Box className="SearchFare_Icon">
              <img src="https://tbi-profile-management-logos.s3.ca-central-1.amazonaws.com/email-template-logos/Icon_loaderImg.png" className='SearchFare_LoaderIcon' />
            </Box>
            <Box className="SearchFare_header">
              <Typography className='SearchFare_LoaderTitle'>{t("Support available")} <span className='SearchFare_Num'>{t("24/7")}</span> !</Typography>
              {window.phone_number && (
                <Typography className='SearchFare_LoaderTel' variant='h4'>
                <CallIcon className='iconTel' /> {window.phone_number}
                </Typography>
            )}
              
            </Box>
          </Box>
          <Box className="SearchFare_LoaderDetails">
            <Typography className='SearchFare_SubTitle' variant='h2'> 
              {/* <FlightIcon className='loader-icon' /> */}
              <img src={LoaderFlightIcon} className='loader-icon' />
              {t("Fastest & cheapest flights")}</Typography>
            <Typography className='SearchFare_SubTitle' variant='h2'> 
              <img src={LoaderBag} className='loader-icon' />
               {t("Secured Transmission")}</Typography>
            <Typography className='SearchFare_SubTitle' variant='h2'>
              <img src={LoaderStar} className='loader-icon' />
              {t("Best Price Guaranteed")} </Typography>
            <Typography className='SearchFare_SubTitle' variant='h2'>
              <img src={LoaderShield} className='loader-icon' />
              {t("Encrypted Storage")}</Typography>
          </Box>
          {/* {!isMobile ? <Box className="SearchFare_LoaderBox">
            <img className="SearchFare_flightImg" src='https://tbi-profile-management-logos.s3.ca-central-1.amazonaws.com/email-template-logos/loading_flight.png' alt='Loding_flight'/>
            <Box className="SearchFare_line SearchFare_line-1"> <FilterDramaIcon/></Box>
            <Box className="SearchFare_line SearchFare_line-2"><FilterDramaIcon/></Box>
            <Box className="SearchFare_line SearchFare_line-3"><FilterDramaIcon/></Box>
            <Box className="SearchFare_line SearchFare_line-4"><FilterDramaIcon/></Box>
            <Box className="SearchFare_line SearchFare_line-5"><FilterDramaIcon/></Box>
          </Box> : null} */}
        </Box>
      </Box>
    }
  </>);
};





export default LogosAnimation;
